import React, { Component } from "react";

class ClickerPattern extends Component {
	constructor(props) {
		super(props);
		this.state = { init: Date.now() };
		this.tref = undefined;
		this.progress = () => ( Date.now() - this.state.init ) / ( this.props.animationDuration * 1000 );
	}

    componentDidMount() {
    	const duration = this.props.animationDuration * 0.74;
    	this.tref = setTimeout( () => this.props.patternClicked(), duration * 1000 );
    }

	handleClick(e) {
		e.preventDefault();
		e.stopPropagation();
		this.props.patternClicked(e, this.progress(), true);
		clearTimeout( this.tref );
	}

	handleTap(e) {
		e.preventDefault();
		e.stopPropagation();
		this.props.patternClicked(e, this.progress(), true);
		clearTimeout( this.tref );
	}

	render() {
		let childStyles = {
			animation: `moveit ${this.props.animationDuration}s ease-out forwards`,
			zIndex: this.props.z
		};
		let panelStyles = {
			backgroundImage: `url( ${this.props.image} )`,
			backgroundSize: 'contain',
			transform: `translateY( ${this.props.vTranslate}px ) rotateZ(${this.props.vRotation}deg)`,
		};

		return (
			<div className={`child lane${this.props.lane}`} style={childStyles}>
				<div
					className={`panel`}
					onMouseDown={e => this.handleClick(e)}
					onTouchStart={e => this.handleTap(e)}
					style={panelStyles}
				/>
				<div className="shadow" />
			</div>
		);
	}
}

export default ClickerPattern;



// WEBPACK FOOTER //
// ./src/components/darkpatterns/ClickerPattern.js